import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class GroupsAdd extends Component{
	render(){
		const {groupsPhases} =this.props;
		let gc = _.find(groupsPhases.permissions, (o) => {return o==='Create'});
		return (
			gc ?
				<p>
					<NavLink to={`/fases/grupos/crear`} className="button is-small is-inm-purple">{'Agregar Grupo'}</NavLink>
				</p>:''
		)
	}
}

export default SecureLayout(GroupsAdd);


// WEBPACK FOOTER //
// ./src/elements/phases/widget/groups_add.jsx